var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays a single good damage entry with status icon, illustration,
 * title, details, and edit/delete actions.
 * touches: good damage declaration flow, room damage store (edit/remove good damage)
 * invariants: isValid reflects isValidGoodDamage(index); showEditButton depends on canDescribe;
 * illustration comes from GOOD_DAMAGE_TYPE_ILLUSTRATIONS
 * inputs: title, details props; type and index from GoodDamageComponent mixin; isValidGoodDamage getter
 * outputs: emits 'edit' with index, emits 'remove'
 * see: frontend/src/declaration/components/roomDamage/goodDamage/GoodDamageComponent.ts,
 * frontend/src/shared/roomDamage/goodDamage.ts
 */
import Component from 'vue-class-component';
import { UiButton, UiIcon, UiList } from '@claims-ia/design-system';
import { GoodDamageComponent } from './GoodDamageComponent';
import { DESCRIBIBLE_GOOD_DAMAGE_TYPES, GOOD_DAMAGE_TYPE_ILLUSTRATIONS, } from '@shared/roomDamage/goodDamage';
let GoodDamageDetailsInput = class GoodDamageDetailsInput extends GoodDamageComponent {
    get items() {
        var _a;
        return [
            {
                id: this.index,
                title: this.title,
                details: this.details,
                imageURL: (_a = this.illustration) !== null && _a !== void 0 ? _a : undefined,
                imageLabel: this.title,
                isActive: false,
                count: 0,
            },
        ];
    }
    get illustration() {
        var _a;
        if (!this.type)
            return null;
        return (_a = GOOD_DAMAGE_TYPE_ILLUSTRATIONS[this.type]) !== null && _a !== void 0 ? _a : null;
    }
    get canDescribe() {
        if (!this.type)
            return false;
        return DESCRIBIBLE_GOOD_DAMAGE_TYPES.includes(this.type);
    }
    get isValid() {
        var _a;
        return (_a = this.isValidGoodDamage(this.index)) !== null && _a !== void 0 ? _a : false;
    }
    get showEditButton() {
        return this.canDescribe;
    }
    get buttonText() {
        return this.isValid
            ? this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.edit')
            : this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.describe');
    }
};
GoodDamageDetailsInput = __decorate([
    Component({
        components: {
            UiButton,
            UiIcon,
            UiList,
        },
        props: {
            title: { type: String, required: true },
            details: { type: String, default: null },
        },
    })
], GoodDamageDetailsInput);
export default GoodDamageDetailsInput;
